import { Link, Navigate, useParams } from "react-router-dom";
import DetailSection from "./DetailSection";
import { programData } from "@/data/mentors";
import { useEffect } from "react";
import Aos from "aos";

export default function DetailHeroSection() {
  const { slug } = useParams();
  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  const mentor = programData.find((item) => item.slug === slug);

  if (!mentor) {
    return <Navigate to="/Future/FutureMentor" replace />;
  }

  return (
    <div className="relative w-full min-h-screen bg-[#FAFAFA] font-sans overflow-x-hidden">
      <div className="absolute top-0 left-0 w-full z-0 h-44 sm:h-72 overflow-hidden pointer-events-none">
        <img
          src="/Mentor/screen 3.png"
          alt="Decoration"
          className="w-full h-full object-cover object-center opacity-50 md:opacity-100"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-8 md:pt-14 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8 space-y-12">
            <div data-aos="fade-right">
              <div className="flex items-center space-x-2 font-medium text-sm md:text-base mb-3">
                <Link
                  to="/"
                  className="hover:underline cursor-pointer transition-colors"
                >
                  Home
                </Link>
                <span>▸</span>
                <Link
                  to="/Future/FutureMentor"
                  className="hover:underline cursor-pointer transition-colors"
                >
                  Tutors
                </Link>
                <span>▸</span>
                <span className="text-[#FF0000]">Profile</span>
              </div>

              <h1 className="text-4xl md:text-6xl font-bold text-black leading-tight tracking-tight mb-3">
                {mentor.title}
              </h1>

              <p className="text-lg md:text-md text-gray-800 font-medium mb-6">
                {mentor.desc}
              </p>
            </div>
          </div>
        </div>
        <DetailSection />
      </div>
    </div>
  );
}
